/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ParkingTypeEnum = (typeof ParkingTypeEnum)[keyof typeof ParkingTypeEnum];

export const ParkingTypeEnum = {
  street: 'street',
  driveway: 'driveway',
  visitor_parking: 'visitor_parking',
  garage: 'garage',
  other: 'other',
} as const;
